import { gql } from '@apollo/client';

export default gql`
  mutation UpdateScheduledSystemAction($id: Int!, $input: UpdateScheduledActionInput!) {
    updateScheduledSystemAction(id: $id, input: $input) {
      success
      message
      log_entry {
        id
        status
        process_status
        scheduled_at
        mail_content
        is_manual_edit
      }
    }
  }
`;
